import React, {useMemo} from 'react';
import {useModelMetadataOptionsUsage, useFileTagUsage} from '../../../../../../store/modelMetadata';
import {ModelMetadataOptionsDTOOptions, MetadataCountDTO} from 'hemwb-api';
import {Table} from 'antd';
import type {ColumnsType} from 'antd/es/table';
import {Link} from 'react-router-dom';
import {getUrlRoute, MRAppRoutes} from '../../../../../router/routes';
import {tid} from '../../../../../../testUtils';
import styles from './UsageList.module.scss';

type UsageListProps = {
  property: keyof ModelMetadataOptionsDTOOptions;
  value: string;
  fileTagCount: MetadataCountDTO[] | undefined;
};

const UsageList: React.FC<UsageListProps> = ({property, value, fileTagCount}) => {
  const usageList = useModelMetadataOptionsUsage(property);
  const FileTagUsageList = useFileTagUsage(fileTagCount);

  const usages = usageList?.[value];
  const fileTagUsages = FileTagUsageList?.[value];

  const affectedModelList = useMemo(() => {
    return !usages?.length ? fileTagUsages : usages;
  }, [usages, fileTagUsages]);

  const columns: ColumnsType<any> = useMemo(
    () => [
      {
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <Link
            to={getUrlRoute(MRAppRoutes.MODEL_DETAIL, {uuid: record.uuid})}
            {...tid('link', 'model-entry', record.uuid)}
          >
            {text}
          </Link>
        ),
      },
    ],
    [],
  );

  if (!affectedModelList || affectedModelList.length === 0) {
    return null;
  }

  return (
    <div className={styles.usageListContainer}>
      <div className={styles.warningSection}>
        <div className={styles.warningIcon}>⚠</div>
        <span>List of model entries that will be affected.</span>
      </div>
      <Table<any>
        columns={columns}
        dataSource={affectedModelList}
        rowKey={(record) => record.uuid}
        pagination={false}
        showHeader={false}
        size="small"
        {...tid('usage-list-table')}
      />
    </div>
  );
};

export default UsageList;
